import i18n from "i18next";
import i18nBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";

i18n.use(i18nBackend)
    .use(detector)
    .use(initReactI18next)
    .init({
        fallbackLng: "en-US",
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: "./loc/{{lng}}.json"
        }
        // resources: {

        // },
  });

export default i18n;